<template>
    <div class="page">
        <pageheader />
        <banner/>
        <router-view/>
        <!-- <pagefooter/> -->
    </div>
</template>
<script>
import Vue from "vue"
import pageheader from "./components/header"
// import pagefooter from "./components/footer"
import banner from "./components/banner"
export default {
    components: {
        pageheader,
        // pagefooter,
        banner
    }
}
</script>
